// App instalado no celular: service worker, cartão "Instale a Sublime" e aviso de sem internet.
// Sem internet o app avisa e não grava nada: ação nenhuma fica guardada para depois (nada se perde nem duplica).
import { useEffect, useState, useSyncExternalStore } from 'react';
import { Icon } from '../ui/Icon.tsx';
import { Sheet } from '../ui/Sheet.tsx';
import { useNav } from './nav.tsx';

export function registerSW() {
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => undefined); });
  }
}

const online = () => navigator.onLine;
const subOnline = (f: () => void) => { window.addEventListener('online', f); window.addEventListener('offline', f); return () => { window.removeEventListener('online', f); window.removeEventListener('offline', f); }; };
export function OffBar() {
  const on = useSyncExternalStore(subOnline, online);
  return on ? null : <div className="off-bar" role="status">Sem internet<small>Dá para olhar o que já abriu. Para gravar, espere a conexão voltar.</small></div>;
}

// o Android oferece o "Instalar app"; guardamos o pedido para usar no botão
type InstallEvent = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: string }> };
let deferred: InstallEvent | null = null;
const subs = new Set<() => void>();
window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); deferred = e as InstallEvent; subs.forEach((f) => f()); });
window.addEventListener('appinstalled', () => { deferred = null; subs.forEach((f) => f()); });
const standalone = () => window.matchMedia?.('(display-mode: standalone)').matches || (navigator as unknown as { standalone?: boolean }).standalone === true;
const KEY = 'sublime-instalar-fechado';

export function InstallCard() {
  const nav = useNav();
  const [, force] = useState(0);
  const [closed, setClosed] = useState(() => { try { return localStorage.getItem(KEY) === '1'; } catch { return false; } });
  useEffect(() => { const f = () => force((n) => n + 1); subs.add(f); return () => { subs.delete(f); }; }, []);
  if (closed || standalone()) return null;
  const close = () => { setClosed(true); try { localStorage.setItem(KEY, '1'); } catch { /* sem armazenamento */ } };
  return (
    <div className="install-card"><span className="install-ic" aria-hidden="true"><i /></span><span><b>Instale a Sublime no celular</b><small>Abre como app, com ícone na tela inicial</small></span>
      <button className="cta sm" onClick={() => nav.open({ kind: 'instalar' })}>Instalar</button><button className="install-x" onClick={close} aria-label="Agora não">×</button></div>
  );
}

export function InstalarSheet() {
  const nav = useNav();
  const [, force] = useState(0);
  useEffect(() => { const f = () => force((n) => n + 1); subs.add(f); return () => { subs.delete(f); }; }, []);
  const install = async () => { if (!deferred) return; await deferred.prompt(); await deferred.userChoice.catch(() => undefined); deferred = null; nav.close(); };
  return (
    <Sheet title="Instalar no celular" actions={<>{deferred && <button className="cta" onClick={install}>Instalar (Android)</button>}<button className="link-back" onClick={nav.close}>Fechar</button></>}>
      <p className="gl-title first">No Android (Chrome)</p>
      <div className="gl"><div className="gl-row wa-step"><span>1</span><b>{deferred ? 'Toque em "Instalar" abaixo' : 'Menu ⋮ do Chrome → Instalar app'}<small>ou "Adicionar à tela inicial"</small></b></div></div>
      <p className="gl-title">No iPhone (Safari)</p>
      <div className="gl">
        <div className="gl-row wa-step"><span>1</span><b>Toque em Compartilhar<small>o quadrado com a seta, embaixo</small></b></div>
        <div className="gl-row wa-step"><span>2</span><b>Adicionar à Tela de Início</b></div>
        <div className="gl-row wa-step"><span>3</span><b>Adicionar</b></div>
      </div>
      <p className="m-hint"><Icon name="info" /> Depois de instalada, abre direto na Hoje, sem a barra do navegador.</p>
    </Sheet>
  );
}
